import { render, staticRenderFns } from "./Quotes.vue?vue&type=template&id=2b02893d&scoped=true&"
import script from "./Quotes.vue?vue&type=script&lang=ts&"
export * from "./Quotes.vue?vue&type=script&lang=ts&"
import style0 from "./Quotes.vue?vue&type=style&index=0&id=2b02893d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b02893d",
  null
  
)

export default component.exports